import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  const handleExploreClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  return (
    <div className="main bg-gray-800 text-white p-8 mt-20">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {/* About Us Section */}
        <div className="flex flex-col md:items-start">
          <h1 className="text-2xl font-bold mb-4">About Us</h1>
          <p className="text-left text-lg">
            Jogula NGO Foundation warmly welcomes you. We are a beacon of hope
            for children in need of basic necessities.
          </p>
        </div>

        {/* Quick Links Section */}
        <div className="flex flex-col md:items-start">
          <h1 className="text-2xl font-bold mb-4">Quick Links</h1>
          <ul className="text-left text-lg space-y-2">
            <li>
              <Link to="/" onClick={handleExploreClick}>
                Home
              </Link>
            </li>
            <li>
              <Link to="/about-us" onClick={handleExploreClick}>
                About
              </Link>
            </li>
            <li>
              <Link to="/volunteer" onClick={handleExploreClick}>
                Volunteer
              </Link>
            </li>
            <li>
              <Link to="/contact" onClick={handleExploreClick}>
                Contact
              </Link>
            </li>
          </ul>
        </div>

        {/* Get In Touch Section */}
        {/* Get In Touch Section */}
<div className="w-full flex justify-end mt-[-1]">
  <div className="flex flex-col md:items-start md:pl-8 max-w-3xl">
    <h1 className="text-2xl font-bold mb-4">Get In Touch</h1>
    <div className="flex flex-col md:flex-row justify-start w-full gap-8">
      <div className="contact-info text-lg md:max-w-md">
        <p className="mb-3">
          <span className="font-bold">Phone:</span> +91 9611295969
        </p>
        <p className="mb-3">
          <span className="font-bold">Email:</span> jogulafoundation@gmail.com
        </p>
        <p className="mb-3">
          <span className="font-bold">Address:</span> #30, 3rd Cross,
          Thulasinagar, Hosahalli Main Road, Doddagollarahatti, Magadi Road,
          Bengaluru - 560091
        </p>
      </div>
      <div className="map-container mt-[-40px] h-52 w-full md:w-80">
        <h2 className=" mt-[-10px] font-bold text-xl font-semibold mb-3 ">Location</h2>
        <iframe
          src="https://maps.google.com/maps?q=12.9926202%2C77.4756731&z=15&hl=en&output=embed"
          width="100%"
          height="100%"
          style={{ border: 0, borderRadius: '4px' }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Jogula Foundation Location"
        ></iframe>
      </div>
    </div>
  </div>
</div>

      </div>

      {/* Powered By Section */}
      <div className="text-center mt-8 pt-4 border-t border-gray-700">
        <a 
          className="inline-block px-3 py-1 bg-black rounded"
          href="https://www.innomatricstech.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span className="text-red-600">Powered By</span>{" "}
          <span className="text-white">Innomatrics Tech Banglore</span>
        </a>
      </div>
    </div>
  );
};

export default Footer;
